import { useState } from 'react';
import { FlexGrid } from '@grapecity/wijmo.react.grid';
// import { Selector } from '@grapecity/wijmo.grid.selector';

import "bootstrap/dist/css/bootstrap.min.css";
import "@grapecity/wijmo.styles/themes/wijmo.theme.material.css";
import "../layout/DataGrid.css";
import ColumnPickerDialog from '../dialog/ColumnPickerDialog';

function DataGrid ( props ) {

    const [grid, setGrid] = useState();
    const [, setColumnPicker] = useState();
    // const [, setSelector] = useState();

    const {

        id,
        gridRef,
        isReadOnly,
        autoGenerateColumns,
        allowSorting,
        allowPinning,
        showMarquee,
        selectionMode,

        onInitialized,
        onBeginningEdit,

        addColumnPicker, // add column picker to top left header cell

        children,
        ...others

    } = props;

    const onGridInitialized = ( grid ) => {

        // setSelector ( new Selector( grid ) );

        grid.showColumnPicker = () => {

            setColumnPicker ( ( columnPicker ) => {
                columnPicker.show ();
                return columnPicker;
            } );

        }

        grid.formatItem.addHandler(function (grid, event) {
            if (event.panel === grid.columnHeaders) {
                var col = grid.columns[event.col];
                // 오름차순
                if (col.currentSort === "+") {
                    event.cell.innerHTML = '<span class="wj-glyph-up"></span> ' + event.cell.innerHTML?.replace('<span class="wj-glyph-up"></span>','');
                    //내림차순이면
                } else if (col.currentSort === "-") {
                    event.cell.innerHTML =
                        '<span class="wj-glyph-down"></span> ' + event.cell.innerHTML?.replace('<span class="wj-glyph-down"></span>','');
                }
            }
        });

        setGrid ( grid );

        if ( onInitialized ) {

            onInitialized ( grid );

        }

    };

    const gridProps = {

        isReadOnly: ( isReadOnly === undefined ) ? true : isReadOnly,
        autoGenerateColumns: autoGenerateColumns === undefined ? false : autoGenerateColumns,
        allowPinning: allowPinning === undefined ?  "SingleColumn" : allowPinning,
        allowSorting: allowSorting === undefined ? "MultiColumn" : allowSorting,
        showMarquee: showMarquee === undefined ? false : showMarquee,
        selectionMode: selectionMode === undefined ? "ListBox" : selectionMode,
        
        initialized: onGridInitialized,
        
        ...others

    }

    const onColumnPickerInitialized = ( columnPicker ) => {

        setColumnPicker ( columnPicker );

    };

    return (

        <FlexGrid ref={gridRef} { ...gridProps } style={{position: "absolute", top: 0, left: 0, bottom: 0, right: 0, padding: 0, margin: 0}}>
            <ColumnPickerDialog id={id+"columnPicker"} grid={grid} onInitialized={onColumnPickerInitialized} />
            { children }
        </FlexGrid>        

    );

}

export default DataGrid;

